module.exports = __webpack_public_path__ + "media/img/logos/tak-mil-icon-e3f4ead901e19d192fd50e31dca4e168.png";